export type PaymentOrder = {
  pay_method: string
  merchant_id: string
  service_id: string
  cust_code: string
  order_id: string
  item_id: string
  amount: string
  pay_type: string
  service_type: string
  success_url: string
  cancel_url: string
  error_url: string
  pagecon_url: string
  request_date: string
  hashkey: string
  purchase_request_url?: string
}

interface Json {
  [key: string]: string
}

export type Payment = {
  id: number
  sbpayment_order_id: string
  user_name: string
  order_id: number
  ticket_number: string
  amount: number
  pay_method: string
  status: string
  request_date: string
  res_date: string
  res_tracking_id: string
  memo?: string
  is_deleted_user: boolean
}

export const paymentStatus: Json = {
  NOT_PURCHASED: '未払い',
  OK: 'クレジット支払い済み',
  NG: '支払い処理NG',
  CANCEL: '支払い処理キャンセル',
  PAID_CANCEL: '支払い済みキャンセル',
  REFUND: '払い戻し'
}

export const paidStatusList = ['OK', 'PAID_CANCEL', 'REFUND']

export const getPaymentEnabled = ($axios: any) => {
  return $axios.$get(`/payments/enabled`)
}

export const paymethod = ($axios: any, param: any) => {
  const params = new URLSearchParams(param)
  return $axios.$post(`/payments/paymethod`, params)
}

export const getPaymentStatus = ($axios: any, orderId: number) => {
  return $axios.$get(`/payments/status?order_id=${orderId}`)
}

export const paymentCancel = ($axios: any, param: any) => {
  const params = new URLSearchParams(param)
  return $axios.$post(`/payments/cancel`, params)
}

export const getPayments = ($axios: any, param: any): Promise<Payment[]> => {
  const params = new URLSearchParams(param)
  return $axios.$get(`/payments/?${params.toString()}`)
}
